import { render, staticRenderFns } from "./ResourceItemInput.vue?vue&type=template&id=526cce80&"
import script from "./ResourceItemInput.vue?vue&type=script&lang=ts&"
export * from "./ResourceItemInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports